import { BaseMmsExternalService } from "services/mms/external-api/BaseExternalService"

export class BaseBusinessService extends BaseMmsExternalService {
    constructor(baseServiceEndpointPrefix: string) {
        const apiURL = import.meta.env.VITE_API_SERVER_URL
        super(apiURL + baseServiceEndpointPrefix)
    }
}
